import { ContactLinkProps } from "./ContactLink"

export const serviceItems: ContactLinkProps[] = [
  {
    url: "https://api.whatsapp.com/send/?phone=972532397240&text&type=phone_number&app_absent=0",
    type: "page",
    label: "מענה מהיר בוואטסאפ",
    linkLabel: "053-2397240",
    icon: "whatsapp",
    blank: true,
  },
  {
    url: "*2880",
    type: "phone",
    label: "מענה טלפוני 24/7",
    icon: "phone",
  },
  {
    url: "service1@delekmotors.co.il",
    type: "email",
    label: "יצירת קשר במייל",
    icon: "mail",
  },
]
export const salesItems: ContactLinkProps[] = [
  {
    url: "/show-rooms",
    type: "page",
    label: "אולמות תצוגה",
    linkLabel: "לתיאום ביקור",
    icon: "location",
  },
  {
    url: "*9888",
    type: "phone",
    label: `מענה טלפוני`,
    extraInfo: "בימים א׳-ה׳ 08:00-17:00",
    icon: "clock",
  },
]
